
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/monthly/[friendlyUrl]",
      function () {
        return require("private-next-pages/monthly/[friendlyUrl].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/monthly/[friendlyUrl]"])
      });
    }
  